module.exports = __webpack_public_path__ + "img/shield-xmark.40e10333.svg";